import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 53267 53269"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="_1970247304704"
        d="M53267 0v12028L38659 26635l14608 14607v12027L26634 26635z"
        className="fil0"
      />
      <path
        id="_1970247303776"
        d="M26634 0v12028L12026 26635l14608 14607v12027L0 26635z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
